import type React from 'react';

import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';

import type { SupporterVideo } from '../../../../../../types';

export const DeleteSuccessMessage: React.FC<{ video: SupporterVideo }> = ({ video }) => {
	return (
		<InlineMessage variant="success" title="Success" mb={8}>
			{video.videoUrl ? 'Video' : 'Comment'} Successfully removed.
		</InlineMessage>
	);
};

export const DeleteErrorMessage: React.FC = () => {
	return (
		<InlineMessage variant="warning" title="Delete failed" mb={8}>
			Something went wrong while deleting.
		</InlineMessage>
	);
};

export const PetitionVideoDeleteMessage: React.FC<{
	message: 'success' | 'error' | undefined;
	video: SupporterVideo;
}> = ({ message, video }) => {
	if (message === 'success') return <DeleteSuccessMessage video={video} />;
	if (message === 'error') return <DeleteErrorMessage />;
	return null;
};
